export default __webpack_public_path__ + "static/media/starswap_wen.7cf44f5c.svg";